import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelButtonLabel: {
    id: 'DeliveryMethodStep.cancelButtonLabel',
    description: 'Cancel button label',
    defaultMessage: 'Cancel',
  },
  shippingMethodTally: {
    id: 'DeliveryMethodStep.shippingMethodTally',
    description: 'Simple translation of "of" word in counting shipping methods',
    defaultMessage: 'Shipment {optionNumber} of {total}',
  },
  updateChangesButtonLabel: {
    id: 'DeliveryMethodStep.updateChangesButtonLabel',
    description: 'Save changes button label',
    defaultMessage: 'Save Changes',
  },
  nextPaymentInfoButtonLabel: {
    id: 'DeliveryMethodStep.nextPaymentInfoButtonLabel',
    description: 'Next - Payment Info button label',
    defaultMessage: 'Continue to Payment',
  },
  smallProductsTitle: {
    id: 'DeliveryMethodStep.smallProductsTitle',
    description: 'Small products title',
    defaultMessage: 'Small items ({quantity})',
  },
  largeProductsTitle: {
    id: 'DeliveryMethodStep.largeProductsTitle',
    description: 'Large products title',
    defaultMessage: 'Large items ({quantity})',
  },
});
